import MdBadge from "./MdBadge"

const MdBadgePlugin = {
  install(app) {
    app.component(MdBadge.name, MdBadge)
  },
}

export default MdBadgePlugin
